import {defineCustomElement, ref} from "vue";
import FloatingWidgetCustomElement from "../CustomElements/FloatingWIdget.ce.vue";
import {
    FLOATING_WIDGET_TYPE,
    FloatingWidgetType
} from "../Contracts/WidgetTypes/FloatingWidgetType";
import {USE_WIDGET_EXPERIENCES, WIDGET_CONFIGURATION} from "../Constants/di";
import {getLogger} from "../Services/LoggingService";
import "@bookingkit/coppi/dist/style.css";
import "../style.css";
import {boostrapCustomElementApp} from "./Bootstrap";
import {applyWhenConnected} from "./applyWhenConnected";
import UseWidgetInventory from "../Widgets/ModalWidget/Composables/useWidgetInventory";
import {InvalidRequestError} from "../Services/BookingkitApi/Errors/InvalidRequestError";
import {AxiosError} from "axios";

export const BootstrapFloatingWidget = defineCustomElement(FloatingWidgetCustomElement, {
    configureApp(app) {
        const readyState = ref(false);
        const widgetConfiguration = ref<FloatingWidgetType|undefined>();
        app.provide('readyState', readyState);
        app.provide(WIDGET_CONFIGURATION, widgetConfiguration);
        boostrapCustomElementApp<FloatingWidgetType>(FLOATING_WIDGET_TYPE, app)
            .then(({configuration, bookingkitApiService, hostElement}) => {
                app.provide(USE_WIDGET_EXPERIENCES,
                    UseWidgetInventory({
                        inventoryService: bookingkitApiService.experienceService,
                        previewToken: configuration?.options?.previewToken,
                        experienceIds: Array.from(new Set([
                            ...configuration.experiencesForTickets,
                            ...configuration.experiencesForVouchers,
                        ])),
                        sortOrder: [...configuration.experiencesSortOrder],
                        flexOfferIds: [...configuration.flexOffers],
                    })
                );

                const punkuInit =
                    configuration.chatBotProvider?.displayChat &&
                    configuration.chatBotProvider?.punku?.publishableKey
                        ? import('../ChatBotProviders/Punku/initPunkuIntegration')
                            .then(({ initPunkuIntegration }) => initPunkuIntegration(configuration))
                        : Promise.resolve();

                // Wait for punku coordinator to register listeners before rendering,
                // so events emitted on mount are not missed.
                return punkuInit.then(() => {
                    applyWhenConnected(hostElement, () => {
                        widgetConfiguration.value = configuration;
                        readyState.value = true;
                    });
                }).catch((e: Error) => {
                    getLogger().error(e);
                })
            })
            .catch((e: Error) => {
                if(!( e instanceof InvalidRequestError) && !( e instanceof AxiosError)) {
                    getLogger().error(e);
                }
            });
    },
});
